import { call, put, select } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { setRoles } from "./actions";
import { getRolesAllRequest } from "./api";
import { rolesSelector } from "./selectors";


const rolesSchema = new schema.Entity("roles");
const permissionsListSchema = new schema.Array(rolesSchema);

function* getRolesWorker() {
    try {
        const { ids } = yield select(rolesSelector);

        if(!ids.length){
            yield put(setRoles({ isLoading: true }));
            const { roles } = yield call(getRolesAllRequest);

            const { result, entities } = normalize(roles, permissionsListSchema);
            yield put(setRoles({
                isLoading: false,
                roles: entities.roles,
                ids: result
            }));
        }
    } catch (error) {
        yield put(setRoles({ isLoading: true }));
        showError(error);
    }
}

export function* getRoles() {
    yield call(getRolesWorker);
}
